(function ($) {
  $('.trd-ph-embedded').on('click', function() {
    var videoUrl = $(this).find('a[data-page-type="video"]').attr('href');
    if (videoUrl) {
      var youtubeId = getYoutubeId(videoUrl);
      if (typeof Munchkin != 'undefined')
        Munchkin.munchkinFunction('clickLink', {
            'href': '/play-trendemon-video-' + youtubeId
          }
        );
    }
  });

  $('.recommendations-list a')
    .on('click', function () {
      if ((typeof ga === 'function' && ga.loaded))
        ga('send', 'event', 'interaction_ad_text', 'click', $(this).text());
  });

  $('.trd-ph-embedded').on('click', function() {
    var videoUrl = $(this).find('a[data-page-type="video"]').attr('href');
    if (videoUrl) {
      var youtubeId = getYoutubeId(videoUrl);
      if (typeof Munchkin != 'undefined')
        Munchkin.munchkinFunction('clickLink', {
            'href': '/play-trendemon-video-' + youtubeId
          }
        );
    }
  });
}) (jQuery);